<template lang="pug">
    .profile-image-actions(@click="openActions" ref="button")
        svg-icon(iconId="pencil")
</template>

<script>
import EventBus from '../lib/event-bus'
import Events from '../lib/events'
import ModalsList from './modals/modals-list'

export default {
    name: 'settings-image-actions',

    computed: {
        options() {
            return [
                { name: 'Delete', value: 'delete' },
                { name: 'Change', value: 'change' },
            ]
        },
    },

    methods: {
        openActions() {
            EventBus.$emit(Events.OPEN_MODAL, ModalsList.SELECT_OPTION, {
                element: this.$refs.button,
                options: this.options,
                handler: this.selectOption,
            })
        },
        selectOption(option) {
            switch (option.value) {
                case 'delete':
                    this.$emit('deletePhoto')
                    break
                case 'change':
                    this.$emit('changePhoto')
                    break
            }
        },
    },
}
</script>
